export class SumAggregator {
    constructor(field) {
        this._sum = 0;
        this._type = 'sum';
        this._field = field;
    }
    get field() {
        return this._field;
    }
    get type() {
        return this._type;
    }
    init() {
        this._sum = 0;
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== '' && !isNaN(val)) {
            this._sum += parseFloat(val);
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals[this._type] === undefined) {
            groupTotals[this._type] = {};
        }
        groupTotals[this._type][this._field] = this._sum;
    }
}
//# sourceMappingURL=sumAggregator.js.map